import { render, staticRenderFns } from "./FulfillmentResume.vue?vue&type=template&id=00159f25&"
import script from "./FulfillmentResume.vue?vue&type=script&lang=js&"
export * from "./FulfillmentResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports